import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PalantirSkeletonComponent } from '../../../../skeleton/skeleton.component';

@Component({
  selector: 'palantir-table-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PalantirSkeletonComponent],
})
export class PalantirTableLoadingComponent {}
